<template>

  <img id="back" src="../../assets/back_white.png" @click="back">
  <div>
    <img id="login_bg" src="@/assets/login_bg.png">
  </div>

  <div id="signup">
  <img id="title" src="@/assets/iv_signup_title.png">
  <div id="content_contain">
    <div id="banner">
      <LoginBanner/>
      <div id="balance">$ {{ indexData ? indexData.data.showBalance.toFixed(2) : '' }}</div>
    </div>

    <div id="login_actions">
      <!-- 邮箱验证码常被投递到垃圾邮件，选中 Email 时气泡提示去 Spam/Junk 里找 -->
      <div id="email_spam_tip" v-show="emailLogin && loginType === 'email'">
        <img src="@/assets/iv_warn.png">
        <div>
          <p class="tip_title">Can't find the email?</p>
          <p class="tip_desc">Check your <span>Spam</span> or <span>Junk</span> folder.</p>
        </div>
      </div>
      <!-- 邮箱登录开关关闭时只保留手机号登录，不显示 Phone/Email 切换 -->
      <div id="login_tabs" v-if="emailLogin">
        <div class="tab" :class="{ active: loginType === 'phone' }" @click="switchType('phone')">Phone</div>
        <div class="tab" :class="{ active: loginType === 'email' }" @click="switchType('email')">Email</div>
      </div>
      <div id="phone_contain" v-show="loginType === 'phone'">
        <p>+1</p>
        <div></div>
        <div></div>
        <input type="tel" inputmode="numeric"  id="phone" name="phone" maxlength="10" placeholder="Type mobile" v-model="mobile" required>
        <img src="@/assets/login_right_icon.png">
      </div>
      <div id="email_contain" v-show="emailLogin && loginType === 'email'">
        <img src="@/assets/ic_email.png">
        <input type="email" inputmode="email" id="email" name="email" autocomplete="email" placeholder="Email address" v-model="email" required>
      </div>
      <div id="otp_contain">
        <input type="tel" inputmode="numeric" @keydown.enter="finish" id="otp" enterkeyhint="done" name="otp" maxlength="4" placeholder="Type your OTP" v-model="otp" required>
        <button id="btn_otp" v-bind:disabled="otpDisable" @click="sendOtp">
          <p>{{ countdownTxt }}</p>
        </button>
      </div>
      <div id="private_contain">
        <div id="private_contain" style="display: flex;flex-direction: row;padding-left: 0rem;"><img style="width: 2rem;height: 2rem; margin-right: 0.5rem;" src="@/assets/iv_info.png"><p>Please do not share your otp with anyone</p></div>
        <p>I agree to <span class="span_privacy" @click="toTerms">the Terms</span> to use and <span class="span_privacy" @click="toPrivacyPolicy">Privacy Policy.</span>
        </p>
      </div>

      <div class="btn_login" @click="login">
        <p>Sign in / Sign up</p>
      </div>

    </div>

    <img src="@/assets/close_circle.png" v-show="!this.$store.state.forceLogin" @click="dissmiss" id="close">
  </div>
  </div>


</template>
<script>
import http, { reportEvent } from '@/utils/http'
import LoginBanner from '@/views/LoginBanner.vue'
import toast from '@/utils/toast'
import bus from 'vue3-eventbus'
import features from '@/config/features'

export default {
  props: {
    indexData: Object
  },
  components: { LoginBanner },
  data () {
    return {
      // 邮箱登录开关（关闭时只手机号登录）
      emailLogin: features.emailLogin,
      // 'phone' | 'email'
      loginType: 'phone',
      mobile: '',
      email: '',
      otp: '',
      countdownTxt: 'Request',
      otpDisable: false,
      checkbox: false
    }
  },
  computed: {
    // TODO: 邮箱登录接口未定，先按 type 区分渠道（1=手机号 2=邮箱），后端定稿后只需改这里
    loginTypeValue () {
      return this.loginType === 'email' ? 2 : 1
    }
  },
  methods: {
    // 登录弹窗打点，走 http 的 reportEvent（同 report.taurus.cash 那套）。
    // 事件名统一 us_login_<动作>_<phone|email>，用后缀区分登录渠道
    reportBuriedPoint (key, value) {
      reportEvent(key, value || '')
    },
    switchType (type) {
      if (this.loginType === type) {
        return
      }
      this.loginType = type
      // 换了接收渠道，之前那条验证码已失效
      this.otp = ''
      // 切换到手机/邮箱
      this.reportBuriedPoint('us_login_switch_' + type, '')
    },
    // 校验当前渠道的输入，通过返回 true
    checkAccount () {
      if (this.loginType === 'email') {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email.trim())) {
          toast.show('please input a valid email')
          return false
        }
        return true
      }
      if (this.mobile.length !== 10) {
        toast.show('please input you mobile')
        return false
      }
      return true
    },
    finish () {
      document.activeElement.blur()
    },
    back () {
      window.parent.postMessage(JSON.stringify({
        action: 'close',
        data: {
          title: 'close',
          iframeId: 'share-iframe'
        }
      }), '*')
      if (window.jskit && window.jskit.finishPage) {
        window.jskit.finishPage();
      }
    },
    toPrivacyPolicy () {
      this.$router.push({
        path: '/landweb',
        query: { url: 'privacyPolicy.html' },
        param: { url: 'privacyPolicy.html' }
      })
    },
    toTerms() {
      this.$router.push({
        path: '/landweb',
        query: { url: 'terms.html' },
        param: { url: 'terms.html' }
      })
    },
    dissmiss () {
      this.$store.commit('showLogin', false)
    },
    login () {
      // 点击登录（区分手机/邮箱），发生在校验之前，只要点了就上报
      this.reportBuriedPoint('us_login_click_' + this.loginType, '')
      // if (!this.checkbox) {
      //   toast.show('Need to agree to privacy policy')
      //   return
      // }
      if (!this.checkAccount()) {
        return
      }
      if (!this.otp.length) {
        toast.show('please input otp')
        return
      }

      const requestData = {
        verifyCode: this.otp,
        type: this.loginTypeValue,
        aid: this.$store.state.aid,
        pn: this.$store.state.pn,
        uid: this.$store.state.uid,
        region: 'US',
        channel: this.channel,
      }
      if (this.loginType === 'email') {
        requestData.email = this.email.trim()
      } else {
        requestData.mobile = '1' + this.mobile
      }
      http.postHttp('/region/user/verifyV2', requestData).then((rep) => {
        if (rep.code === 0) {
          this.$store.commit('user', rep.user)
          this.$store.commit('finish_task_count', rep.finish_task_count)
          this.$store.commit('linkUrl', rep.user.url)
          this.$store.commit('mobile', rep.user.mobile)
          this.$store.commit('code', rep.user.code)
          if (rep.token) {
            this.$store.commit('token', rep.token)
          }
          // 先关弹窗：后面的 bus 回调（iOS 原生桥）和 localStorage 都可能抛异常，
          // 放在后面的话一抛弹窗就关不掉了（iOS 上已登录但弹窗不消失）
          this.dissmiss()
          try {
            localStorage.setItem('login_state', '1')
            // 记录本次登录渠道，供提现验证弹窗判断走手机还是邮箱验证
            localStorage.setItem('us_login_type', this.loginType)
            if (this.loginType === 'email') {
              localStorage.setItem('us_login_email', this.email.trim())
            } else {
              localStorage.removeItem('us_login_email')
            }
          } catch (e) {
            console.log(e)
          }
          bus.emit('login_action', true)
        } else {
          toast.show(rep.msg)
        }
      })
    },
    sendOtp () {
      // 点击获取 OTP（区分手机/邮箱），发生在校验之前，只要点了就上报
      this.reportBuriedPoint('us_login_otp_' + this.loginType, '')
      if (!this.checkAccount()) {
        return
      }
      const requestData = {
        type: this.loginTypeValue,
        pn: this.$store.state.pn,
        uid: this.$store.state.uid
      }
      let url
      if (this.loginType === 'email') {
        const email = this.email.trim()
        requestData.email = email
        url = `/region/user/get_verify_code?type=${this.loginTypeValue}&email=${encodeURIComponent(email)}&region=US&pn=${this.$store.state.pn || ''}`
      } else {
        const mobile = '1' + this.mobile
        requestData.mobile = mobile
        url = `/region/user/get_verify_code?mobile=${mobile}&type=${this.loginTypeValue}&region=US`
      }
      http.getHttp(url, requestData).then((rep) => {
        if (rep.code === 0) {
          this.startCountDown()
        } else {
          toast.show(rep.msg)
        }
      })
    },
    startCountDown () {
      let countdown = 60
      this.otpDisable = true
      const that = this
      const countdownInterval = setInterval(function () {
        if (countdown > 0) {
          that.countdownTxt = countdown + 'S'
          countdown--
        } else {
          that.countdownTxt = 'Request'
          that.otpDisable = false
          clearInterval(countdownInterval)
        }
      }, 1000)
    }
  },
  mounted () {
    // 登录框展示，区分当前默认渠道（手机/邮箱）
    this.reportBuriedPoint('us_login_show_' + this.loginType, '')
  }
}

</script>

<style scoped>

#back {
  width: 5.7rem;
  height: 5.1rem;
  align-self: center;
  margin-left: 5rem;
  position: absolute;
  top: 1.8rem;
  left: 0;
  z-index: 10;
}

#login_bg {
  margin-top: 6.4rem;
  width: 105.7rem;
  height: 51.1rem;
}

#signup {
  width: 100rem;
  height: 44rem;
  display: flex;
  flex-direction: column;
  position: absolute;
  align-items: center;
}

#content_contain {
  width: 100rem;
  height: 44rem;
  display: flex;
  position: absolute;
  top: 17.5rem;
  left: auto;
  align-items: center;
  justify-content: center;
  padding-left: 3rem;
  padding-right: 3rem;
}

#title {
  width: 54.5rem;
  height: 13.4rem;
  margin-top: 10rem;
}

#banner {
  width: 52.6rem;
  align-self: center;
  border-radius: 0.6rem;
  height: 28.2rem;
  display: flex;
  justify-content: center;
}

#balance {
  width: 19.1rem;
  height: 6.4rem;
  position: absolute;
  justify-self: center;
  top: 18%;
  background-size: 100% 100%;
  z-index: 10;
  background-image: url("@/assets/bg_login_balance.png");
  font-family: Inter;
  font-size: 2.8rem;
  font-style: normal;
  font-weight: 700;
  text-align: center;
  justify-content: center;
  align-content: center;
  color: #FFFCB2;
  padding-top: 2rem;
  display: flex;
}

#login_actions {
  width: 37rem;
  /* 比 banner(28.2rem) 高一点，给 Phone/Email 页签腾空间，上下各溢出约 1.2rem */
  height: 30.6rem;
  align-self: center;
  margin-left: 2.5rem;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  /* 垃圾邮件提示气泡以此为定位参照 */
  position: relative;
}

/* 垃圾邮件提示气泡：浮在 Phone/Email 页签上方，尾巴指向页签 */
#email_spam_tip {
  position: absolute;
  left: -0.5rem;
  bottom: calc(100% + 1.4rem);
  width: 38rem;
  display: flex;
  align-items: center;
  padding: 0.9rem 1rem 0.9rem 0.8rem;
  border-radius: 1.2rem;
  background: linear-gradient(180deg, #FFDC5B 0%, #FFC01F 100%);
  box-shadow: 0 0.4rem 0.6rem rgba(0, 0, 0, 0.25);
  z-index: 11;
}

#email_spam_tip::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 100%;
  margin-left: -1.3rem;
  border-left: 1.3rem solid transparent;
  border-right: 1.3rem solid transparent;
  border-top: 1.4rem solid #FFC01F;
}

#email_spam_tip > img {
  width: 3.7rem;
  height: 3.4rem;
  flex: none;
  margin-right: 0.8rem;
}

/* 标题：上下渐变红字 + 黄色描边，描边用 ::before 垫在下层（渐变字要占用 fill，描不了边） */
.tip_title {
  position: relative;
  font-size: 2.4rem;
  font-weight: bolder;
  line-height: 2.9rem;
  background: linear-gradient(180deg, #940303 0%, #FF3C3C 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}

.tip_title::before {
  content: "Can't find the email?";
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  -webkit-text-stroke: 0.3rem #FFFB05;
  color: transparent;
}

.tip_desc {
  font-size: 1.9rem;
  font-weight: bolder;
  line-height: 2.4rem;
  color: #680606;
  /* 保证「Check your Spam or Junk folder.」始终一行 */
  white-space: nowrap;
}

.tip_desc > span {
  color: #FF4800;
}

#login_tabs {
  width: 100%;
  height: 3.9rem;
  flex: none;
  display: flex;
}

#login_tabs > .tab {
  flex: 1;
  text-align: center;
  font-size: 2.6rem;
  font-weight: bolder;
  line-height: 3.2rem;
  color: #FFFFFF;
  padding-bottom: 0.4rem;
  border-bottom: 0.3rem solid rgba(255, 255, 255, 0.45);
}

#login_tabs > .tab.active {
  color: #FFE23D;
  border-bottom-color: #FFE23D;
}

#login_tabs > .tab:active {
  opacity: 0.7;
}

#email_contain {
  background: white;
  height: 5.8rem;
  width: 100%;
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  padding: 0 1.3rem;
}

/* 图标源尺寸 38x27，按设计稿 1:0.1rem 等比 */
#email_contain > img {
  width: 3.8rem;
  height: 2.7rem;
  flex: none;
  margin-right: 1.2rem;
}

#email_contain > input {
  flex: 1;
  min-width: 0;
  height: 80%;
  border: none;
  color: #111111;
  font-size: 2.2rem;
  font-weight: bolder;
  outline: transparent;
  background: transparent;
}

#phone_contain {
  background: white;
  height: 5.8rem;
  width: 100%;
  border-radius: 0.4rem;
  display: flex;

  align-items: center;
}

#phone_contain > :first-child {
  font-weight: bolder;
  font-size: 2.2rem;
  color: #111111;
  line-height: 2.8rem;
  padding: 1.3rem;
}

#phone_contain > :nth-child(2) {
  width: 0;
  height: 0;
  border-top: 1rem solid #CCCCCC;
  border-right: 1rem solid transparent;
  border-bottom: 1rem solid transparent;
  border-left: 1rem solid transparent;
  margin-top: 1rem;
}

#phone_contain > :nth-child(3) {
  width: 0.1rem;
  height: 3rem;
  margin-left: 1rem;
  margin-right: 1rem;
  background: #CCCCCC;
}

#phone_contain > :nth-child(4) {
  width: 21rem;
  height: 80%;
  border: none;
  color: #111111;
  font-size: 2.2rem;
  max-lines: 1;
  font-weight: bolder;
  outline: transparent;
  background: transparent;
}

#phone_contain > :nth-child(5) {
  width: 2.9rem;
  height: 3.2rem;
}

#otp_contain {
  height: 5.8rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#otp_contain > :first-child {
  width: 20rem;
  height: 5.8rem;
  background: white;
  border-radius: 0.4rem;
  color: #111111;
  font-size: 2.2rem;
  max-lines: 1;
  border: none;
  font-weight: bolder;
  outline: transparent;
  padding-left: 2rem;
  margin-right: 1rem;
}

#btn_otp {
  width: 15.1rem;
  height: 5.7rem;
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  background-color: transparent;
  background-image: url("@/assets/bg_request.png");
  background-size: cover;
}

#btn_otp:active {
  opacity: 0.6;
}

#btn_otp > p {
  font-weight: bolder;
  align-self: center;
  text-shadow: 0.2rem 0.2rem 0 #BB2B11, 1px 0.2rem 0 #BB2B11, 0.2rem 1px 0 #BB2B11, 1px 1px 0 #BB2B11;
  font-size: 2.3rem;
  color: #FBF4BA;
}

#private_contain {
  display: flex;
  justify-items: center;
  flex-direction: column;
  padding-left: 1rem;
  width: 120%;
}

#cb_privacy {
  width: 2.6rem;
  height: 2.6rem;
  margin-right: 1.4rem;
  background-color: #15C457;
  border-radius: 0.4rem;
}

input[type=checkbox] {
  cursor: pointer;
  position: relative;
  width: 1.8rem;
  height: 1.8rem;
  font-size: 1.2rem;
}

input[type=checkbox]::after {
  position: absolute;
  top: 0;
  color: #000;
  width: 1.8rem;
  height: 1.8rem;
  display: inline-block;
  visibility: visible;
  padding-left: 0;
  text-align: center;
  content: ' ';
  border-radius: 0.3rem
}

input[type=checkbox]:checked::after {
  width: 2.6rem;
  height: 2.6rem;
  background-color: #15C457;
  background-image: url("@/assets/vector_right.png");
  background-size: 80% 80%;
  background-position: center;
  background-repeat: no-repeat;
}

#private_contain > p {
  color: white;
  font-weight: bolder;
  font-size: 1.4rem;
}

.span_privacy {
  color: #FFF022;
  text-decoration-line: underline;
  font-size: 1.4rem;
}

.btn_login {
  background-image: url("@/assets/btn_green.png");
  background-size: 100% 100%;
  width: 100%;
  height: 7.7rem;
  display: flex;
  justify-content: center;
  align-content: center;
}

.btn_login:active {
  opacity: 0.6;
}

.btn_login > p {
  color: white;
  font-weight: bolder;
  font-size: 2.8rem;
  margin-top: 1.2rem;
}

#close {
  width: 5.4rem;
  height: 5.4rem;
  position: absolute;
  right: 0;
  top: -6rem;
  opacity: 1;
}

#close:active {
  opacity: 0.6;
}
</style>
